import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  bottom: 70px;
  left: 50%;
  margin-left: -45px;
  z-index: 0;
`;
